import MuiBadge, {
  type BadgeProps as MuiBadgeProps,
} from "@mui/material/Badge";

import { TestProps } from "shared/types";

export type AllowedBadgeColors = Extract<MuiBadgeProps["color"], "primary">;

export type BadgeProps = Omit<MuiBadgeProps, "color"> & {
  color?: AllowedBadgeColors;
} & TestProps;

const Badge = ({ children, testId, ...props }: BadgeProps) => (
  <MuiBadge data-testid={testId} {...props}>
    {children}
  </MuiBadge>
);

export default Badge;
